"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});


var emptyFunction = function emptyFunction(e) {
  if (e && e.preventDefault) e.preventDefault();
};

exports.default = emptyFunction;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ../mcs-lite-ui/lib/utils/emptyFunction.js
// module id = 550
// module chunks = 4